import { render, staticRenderFns } from "./ImageFrame.vue?vue&type=template&id=57e505a2&scoped=true&"
import script from "./ImageFrame.vue?vue&type=script&lang=ts&"
export * from "./ImageFrame.vue?vue&type=script&lang=ts&"
import style0 from "./ImageFrame.vue?vue&type=style&index=0&id=57e505a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e505a2",
  null
  
)

export default component.exports